ixModuleRouting("impactx.multimedia", {
    "/emptymmdlist": {
        template: "<ixa-empty-mmd-list></ixa-empty-mmd-list>",
        templateUrl: "modules/multimedia/templates/emptymmdlist.tmpl.html",
        controller: "EmptyMMDListCtrl",
        controllerAs: "emptyMMDListCtrl",
        process: "Any",
        workspace: "content",
    },
});
